module.exports = __webpack_public_path__ + "static/david-c1bb8c75a6a7549e74cfb15fb62fd678.png";